import React from 'react';
import PropTypes from 'prop-types';
import './SortFilters.css';

function SortFilters({ updateSortOrder, sortOrder }) {

  const otherOption = (sortOrder === 'date') ? 'relevance' : 'date';

  function switchSortOrder(e) {
    e.preventDefault();
    updateSortOrder(otherOption);
  }

  return (
    <div >
      {sortOrder === 'date' ? (
        <div className="sortFilters"><span className="current">Sort by date</span> / <a href="#sortByRelevance" aria-controls="search-results" onClick={(e) => switchSortOrder(e)}>Sort by relevance</a></div>
      ) : (
        <div className="sortFilters"><a href="#sortByDate" aria-controls="search-results" onClick={(e) => switchSortOrder(e)}>Sort by date</a> / <span className="current">Sort by relevance</span></div>
      )}
    </div>
  );
}

export default SortFilters;

SortFilters.propTypes = {
  sortOrder: PropTypes.string.isRequired,
  updateSortOrder: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/SortFilters.js